import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://qmrgilwqiyoaexarnyca.supabase.co'
const supabaseKey = "sb_publishable_OPOARv1QeYD8KI162iYC1A_qUYBH1dc"
export const supabase = createClient(supabaseUrl, supabaseKey)